/* eslint-disable react-hooks/exhaustive-deps */
import { useFormContext, useWatch } from "react-hook-form"
import { PaymentDepositCustomerType } from "../types"
import { useDepositCode } from "../utils/hooks"

export const CodeDeposit = ({ isEdit }: { isEdit: boolean }) => {
  const { control, setValue, formState } =
    useFormContext<PaymentDepositCustomerType>()

  const [transaction_date, trx_code, sales_order_id] = useWatch({
    control,
    name: ["transaction_date", "trx_code", "sales_order_id"]
  })

  useDepositCode({
    key: formState.submitCount,
    trx_date: transaction_date,
    onSuccess: (data) => {
      setTimeout(() => setValue("trx_code", data), 1000)
    },
    enabled: !isEdit && Boolean(transaction_date) && Boolean(sales_order_id)
  })

  return <div>{trx_code}</div>
}
